import { useMutation } from '@tanstack/react-query'
import { submitFeedback, FeedbackCreate } from '@/api/feedbackService'

/**
 * Mutation hook for submitting feedback on a bot response.
 */
export function useSubmitFeedback() {
  return useMutation({
    mutationFn: (data: FeedbackCreate) => submitFeedback(data),
  })
}
